"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const reviewDecisionStatusHelper_1 = require("../../../services/admin/reviewDecisionStatusHelper");
const InterviewSearchResult = (props) => {
    const interviewUrl = `/survey/edit/${props.interview.uuid}/`;
    return (react_1.default.createElement("li", { title: props.interview.uuid, key: props.key, className: (0, reviewDecisionStatusHelper_1.getInterviewSearchResultClassName)({
            reviewStatus: props.interview.reviewStatus,
            isCompleted: props.interview.isCompleted
        }) },
        props.t('admin:interviewSearch:InterviewUser'),
        ': ',
        props.interview.email ||
            props.interview.username ||
            (props.interview.facebook
                ? props.t('admin:interviewSearch:FromFacebook')
                : props.interview.google
                    ? props.t('admin:interviewSearch:FromGoogle')
                    : props.t('admin:interviewSearch:UnknownUser')),
        ' ',
        "\u2022",
        ' ',
        props.interview.isCompleted === true
            ? props.t('admin:CompletedFemSingular')
            : props.interview.isCompleted === false
                ? props.t('admin:NotCompletedFemSingular')
                : props.t('admin:UnknownCompletionFemSingular'),
        ' ',
        "\u2022 ",
        props.t(`admin:reviewStatus:${props.interview.reviewStatus}`),
        " \u2022",
        ' ',
        props.interview.home.address || props.t('admin:interviewSearch:UnknownAddress'),
        ",",
        ' ',
        props.interview.home.city || '',
        " \u2022",
        ' ',
        react_1.default.createElement("a", { href: interviewUrl, id: `interviewButtonList_${props.interview.uuid}`, "data-uuid": props.interview.uuid, target: "_blank", rel: "noreferrer" }, props.t('admin:interviewSearch:Open'))));
};
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(InterviewSearchResult);
//# sourceMappingURL=InterviewSearchResult.js.map